import React from 'react';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';
import decode from 'entity-decode';

export const MediaTitleContainer = styled.h1`
   font-size: 1.5rem;
   font-weight: ${cssConstants.semiBoldWeight};
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   flex-grow: 1;
   padding-right: 1rem;
   margin: 0;
`;

interface IMediaTitleProps {
   text: string;
}

const MediaTitle: React.FC<IMediaTitleProps> = ({text}) => (
   <MediaTitleContainer title={decode(text)}>
      <span>{decode(text)}</span>
   </MediaTitleContainer>
);

export default MediaTitle;
